"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var groupStyles = require("../../RadioGroup.scss");
var styles = require("./RadioButton.scss");
var RadioButton = function (props) {
    var inputRef = React.useRef(null);
    var labelRef = React.useRef(null);
    var guid = function () {
        return "" + S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
    };
    var S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    var handleClick = function (e) {
        var elem = e.target;
        if (e.screenX === 0 && e.screenY === 0) {
            elem.setAttribute("event-type", "keyboard");
        }
        else {
            elem.setAttribute("event-type", "mouse");
        }
    };
    var onKeyUp = function (e) {
        if (props.events && props.events.onKeyPress) {
            props.events.onKeyPress(e.currentTarget.value);
        }
    };
    var getBottomMargin = function () {
        return { marginBottom: props.last ? "0px" : props.spacing + "px" };
    };
    var renderChildren = function () {
        if (props.children) {
            return React.createElement("div", null, props.children);
        }
        return null;
    };
    var classes = [
        props.classes ? props.classes.join(" ") : "",
        props.className,
        props.disabled ? styles.disabled : "",
        props.card
            ? (props.selected ? styles.radioCardActive : styles.radioCardDefault) + " pad-xs"
            : "",
        props.error ? styles.error + " error" : "",
        props.elementsDirection === "column" ? "flex" : "inline-flex",
        "radio flex-items-top",
    ];
    var inputId = guid();
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { style: props.card ? getBottomMargin() : undefined, ref: labelRef, htmlFor: inputId, "data-testid": props.testId, className: classes.join(" ").trim() },
            React.createElement("input", { id: inputId, "aria-label": props.accessibilityText ? props.accessibilityText : props.value, "aria-describedby": props.errorMessage ? props.hintId : undefined, type: "radio", name: props.name, checked: props.selected, onClick: handleClick, onChange: props.events ? props.events.onChange : undefined, onKeyUp: onKeyUp, "event-type": "keyboard", ref: inputRef, value: props.value, "aria-invalid": props.error, disabled: props.disabled }),
            React.createElement("div", { className: "radio-skin" }),
            React.createElement("span", { className: "rad-chk-txt", "aria-hidden": true }, props.customLabel ? renderChildren() : props.value),
            props.customLabel ? null : renderChildren()),
        props.errorMessage && (React.createElement("div", { className: ["formfield-msg", groupStyles.radioGroupError].join(" "), "aria-live": "polite", "aria-atomic": false, "aria-hidden": false, tabIndex: -1 }, props.errorMessage))));
};
exports.default = RadioButton;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/RadioGroup/components/RadioButton/RadioButton.js
// module id = 1516
// module chunks = 8